<template>
  <div class="page-container md-layout-column">

    <md-drawer class="md-right" :md-active.sync="showSidepanel">
      <md-toolbar class="toolbar-title" md-elevation="0" >
        <span class="md-title">Filtros</span>
      </md-toolbar>

      <md-list>    
        <md-list-item>
          <div class="md-list-item-text">
            <md-button class="md-raised md-primary" @click="onApplyFilter()">Aplicar</md-button>
          </div>
        </md-list-item>

        <md-list-item>
          <div class="md-list-item-text">
            <md-subheader>Rango de minutos</md-subheader>

            <label class="pe-radio" v-for="(minute) in this.minutes" :key="minute">
              <input type="radio" v-model="selectedMinutes" :value="minute" name="radio">
              <span class="checkmark"></span>
              <span class="pe-radio-text">{{ minute }}</span>
            </label>
          </div>
        </md-list-item>        
        
        <md-list-item>
          <div class="md-layout-item">
            <md-subheader for="selectedDucto">Ducto</md-subheader>
          </div>
        </md-list-item>
        <li class="custom-select">
          <multiselect v-model="selectedDucto" :options="ductos" :max-height=200 placeholder="Seleccione el ducto"
            label="section_name" track-by="id_section" selectLabel="Seleccionar" deselectLabel="Deseleccionar">
          </multiselect>
        </li>

        <md-list-item>
          <div class="md-layout-item">
            <md-subheader for="selectedStations">Estaciones</md-subheader>
          </div>
        </md-list-item>
        <li class="custom-select">
          <multiselect v-model="selectedStations" :options="filteredStations" :max-height=200 
            :multiple="true"
            :close-on-select="false" 
            :clear-on-select="false" 
            selectLabel="◯" 
            selectedLabel="✔" 
            deselectLabel="✖" 
            placeholder="Seleccione las estaciones" label="site_name" track-by="id_site" 
            selectGroupLabel="Seleccionar todo" deselectGroupLabel="Deseleccionar todo"
            group-values="sites" group-label="section_name" :group-select="true">
            <template slot="selection" slot-scope="{values, search, isOpen}">
              <span class="multiselect__single" v-if="values.length &amp;&amp; !isOpen">{{ values.length }}
                activa(s)</span>
            </template>
            <template slot="noOptions">Lista vacía</template>
            <template slot="noResult">No se encontraron resultados</template>
          </multiselect>
        </li>

      </md-list>
    </md-drawer>

    <md-content>
      <div class="chart-container" v-if="this.isChartVisible">
        <div v-for="(row, index) in this.seriesList" :index="index" :key="row.name">
          <md-toolbar class="toolbar-title" md-elevation="0">
            <span class="md-title chart-head">{{ row.name }}</span>
            <span class="chart-subhead">
              Última actualización: {{
                row.series[0].data.length > 0
                  ? new Date(row.series[0].data[row.series[0].data.length - 1].x).toLocaleTimeString('es-ES', { hour: '2-digit', minute: '2-digit', second: '2-digit', hour12: true }) 
                  : 'N/A' 
              }}
          </span>
          </md-toolbar>
          <apexchart height="300" :options="row.options" :ref="`rows`" :series="row.series"></apexchart>

          <div v-if="row.loading" class="loading-spinner">
            <div>
              <p>
                <i class="fa fa-spinner fa-spin fa-3x fa-fw"></i>
            </p>
            <p>Cargando...</p>
            </div>
          </div>
          <div v-else-if="row.error" class="error-message">
            <span>{{ row.errorMessage }}</span>
          </div>
        </div>
      </div>

      <md-empty-state v-if="this.isInitialSetup" md-rounded md-icon="settings" md-label="Nada que graficar"
        md-description="Seleccione las opciones de graficas desde el boton de agregar filtros">
      </md-empty-state>

      <md-speed-dial class="md-bottom-right speed-dial" md-direction="bottom" md-event="click"
        @click.native="showSidepanel = true">
        <md-speed-dial-target class="md-primary">
          <md-icon>add</md-icon>
        </md-speed-dial-target>
      </md-speed-dial>

    </md-content>
  </div>
</template>

<script>
import _ from 'lodash';

export default {
  data: () => ({
    showSidepanel: true,
    ductos: [],
    selectedStations: null,
    minutes: [15, 30, 45, 60],
    selectedMinutes: 15,
    selectedDucto: null,
    filterDuctos: [],
    filterMinutes: 0,
    isChartVisible: false,
    isInitialSetup: true,
    isDestroyed: false,
    seriesList: [],
    intervals: {},
    chartOptions: {
      noData: {
        text: ''
      },
      chart: {
        type: 'line',
        width: '100%',
        height: '100%',
        responsive: true,
        maintainAspectRatio: false,
        zoom: {
          type: 'x',
          enabled: true,
          autoScaleYaxis: true
        },
        toolbar: {
          autoSelected: 'zoom'
        },
        animations: {
          enabled: true,
          easing: 'linear',
          dynamicAnimation: {
            speed: 1000
          }
        },
      },
      dataLabels: {
        enabled: false,
      },
      stroke: {
        curve: 'smooth',
        width: 1.9,
      },
      title: {
        text: '',
        align: 'left'
      },
      markers: {
        size: 0,
      },
      yaxis: {
        forceNiceScale: true,
        tickAmount: 6,
        logarithmic: false,
        title: {
          text: '',
        },
        max: function (value) {
          return value * 1.01;
        },
        min: function (value) {
          return value * 0.99;
        }
      },
      xaxis: {
        type: 'category',
        tickAmount: 4,
        tooltip: {
          enabled: false,
        },
        labels: {
          show: true,
          rotate: 0,
          rotateAlways: false,
          hideOverlappingLabels: true,
          showDuplicates: false,
        },
        axisTicks: {
          show: true,
        },
      },
    },
  }),
  computed: {
    filteredStations() {
      if (!this.selectedDucto) {
        return this.ductos;
      }
      return this.ductos.filter(q => q.id_section === this.selectedDucto.id_section);
    }
  },
  mounted() {
    this.$store
      .dispatch('LOAD_OPS')
      .then((resp) => {
        this.ductos = resp;
      })
      .catch((err) => {
        console.log(err);
      });
  },
  beforeDestroy() {
    this.clearAllIntervals();
    this.isDestroyed = true;
  },
  methods: {
    onApplyFilter() {
      this.filterDuctos = this.selectedStations;
      this.filterMinutes = this.selectedMinutes;

      this.seriesList = [];

      if (this.filterDuctos && this.filterDuctos.length > 0) {
        this.filterDuctos.forEach(q => {
          q.report_data_id = 0;
        });

        this.isInitialSetup = false;
        this.showSidepanel = false;
        this.isChartVisible = true;

        this.updateEmptyCharts();

        this.loadDecimationSites();
      }
    },
    updateEmptyCharts() {
      this.seriesList = [];

      this.filterDuctos.forEach(x => {
        const ducto = this.ductos.find(d => d.id_section === x.id_section);
        const site = ducto.sites.find(s => s.id_site === x.id_site);

        const chartName = ducto.id_section + ' - ' + site.site_name;
        this.seriesList.push({
          series: [{
            name: chartName,
            data: [],
          }],
          name: chartName,
          options: this.chartOptions,
          loading: true,
          error: false,
          errorMessage: 'No fue posible cargar los datos, intente reducir el rango de fechas'
        });
      });
    },
    loadDecimationSites() {
     if (this.isDestroyed) {
        return;
      }

      for(let i = 0; i < this.filterDuctos.length; i++) {
        const ducto = this.filterDuctos[i];
        this.loadDecimationSite(ducto);
      }
    },
    loadDecimationSite(ducto) {
      const chartName = ducto.id_section + ' - ' + ducto.site_name;

      this.clearIntervalForSite(chartName);

      if (this.isDestroyed) {
        return;
      }

      const request = {
        sites: [ducto]
      };
      const sites_json = JSON.stringify(request);
      var targetData = this.seriesList.filter(q => q.name === chartName);

      this.$store
        .dispatch('LOAD_DECIMATION_SITES', {
          minutes: this.filterMinutes,
          sites_json: btoa(sites_json)
        })
        .then((resp) => {
          this.addChartData(chartName, resp, ducto, targetData[0]);
        })
        .catch((err) => {
          console.log('Error:', err);
          targetData.forEach(q => {
            if(!q.loading) {
              q.errorMessage = 'No fue posible cargar los datos, intente nuevamente';
            }
            q.loading = false;
            q.error = true;
          });
        });
    },
    addChartData(chartName, reportData, ducto, targetData) {
      let chartData = [];

      if(reportData && reportData.data && reportData.data.data) {
        chartData = reportData.data.data;
      }
      const wasLoading = targetData.loading;
      targetData.loading = false;
      targetData.error = false;

      let data = [];

      if (chartData && chartData.length > 0) {
        var last = chartData[chartData.length - 1];
        ducto.report_data_id = last.report_data_id;
        data = chartData.map(q => ({ x: q.report_date, y: q.data, timestamp: q.timestamp }));
      }

      const index = this.seriesList.indexOf(targetData);

      if (wasLoading && data.length === 0) {
        const chartOptions = _.cloneDeep(this.chartOptions);
        chartOptions.noData.text = 'No hay datos disponibles';
        this.$refs.rows[index].updateOptions(chartOptions);
      } else if(data.length > 0) {
        var series = targetData.series[0];
        series.data = series.data.concat(data);

        this.$refs.rows[index].updateSeries([{
          data: series.data
        }]);
        this.setIntervalForSite(chartName, () => this.loadDecimationSite(ducto), 1000);
      } else {
        this.setIntervalForSite(chartName, () => this.loadDecimationSite(ducto), 1000 * 10);
      }
    },
    setIntervalForSite(siteId, callback, interval) {
      this.clearIntervalForSite(siteId);
      this.intervals[siteId] = setInterval(callback, interval);
    },
    clearIntervalForSite(siteId) {
      if (this.intervals[siteId]) {
        clearInterval(this.intervals[siteId]);
        delete this.intervals[siteId];
      }
    },
    clearAllIntervals() {
      for (const siteId in this.intervals) {
        clearInterval(this.intervals[siteId]);
      }
      this.intervals = {};
    },
  }
}
</script>

<style lang="scss" scoped>
.speed-dial {
	position: fixed;
	z-index: 5;
}

.chart-head {
	margin-right: 1.5rem;
}

.chart-subhead {
	margin: .5rem 0;
	padding-left: 1rem;
	padding-top: 0.5rem;
	padding-bottom: 0.5rem;
	padding-right: 1rem;
	font-size: 12px;
	font-weight: 400;
	background-color: #0071C7;
	border-radius: 1.5rem;
	color: #fff;
}

.custom-select {
  padding: 4px 16px;
}

.md-drawer {
  height: 100vh;
  position: fixed;
  width: 320px;
  max-width: calc(100vw - 125px);
  z-index: 100;
}

.toolbar-title {
  min-height: 44px;
}

.md-radio {
  margin: 0;
}

.md-datepicker {
  margin: 0;
}

.md-list {
  margin: 0;
}

/* The switch - the box around the slider */
.switch {
  position: relative;
  display: inline-block;
  width: 30px;
  height: 17px;
}

/* Hide default HTML checkbox */
.switch input {
  opacity: 0;
  width: 0;
  height: 0;
}

/* The slider */
.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  -webkit-transition: .4s;
  transition: .4s;
}

.slider:before {
  position: absolute;
  content: "";
  height: 13px;
  width: 13px;
  left: 2px;
  bottom: 2px;
  background-color: white;
  -webkit-transition: .4s;
  transition: .4s;
}

input:checked+.slider {
  background-color: var(--radio-button-checked);
}

input:focus+.slider {
  box-shadow: 0 0 1px var(--radio-button-checked);
}

input:checked+.slider:before {
  -webkit-transform: translateX(13px);
  -ms-transform: translateX(13px);
  transform: translateX(13px);
}

/* Rounded sliders */
.slider.round {
  border-radius: 17px;
}

.slider.round:before {
  border-radius: 50%;
}

.slider-text {
  margin: 0 8px;
  font-size: 12px;
  position: absolute;
  cursor: pointer;
}

/* The container */
.pe-radio {
  display: block;
  position: relative;
  padding-left: 17.5px;
  margin-bottom: 6px;
  cursor: pointer;
  font-size: 22px;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

.pe-radio-text {
  font-size: 14px;
  margin: 0 8px;
  display: block;
}

/* Hide the browser's default radio button */
.pe-radio input {
  position: absolute;
  opacity: 0;
  cursor: pointer;
}

/* Create a custom radio button */
.checkmark {
  position: absolute;
  top: 0;
  left: 0;
  height: 16px;
  width: 16px;
  background-color: #eee;
  border-radius: 50%;
}

/* On mouse-over, add a grey background color */
.pe-radio:hover input~.checkmark {
  background-color: #ccc;
}

/* When the radio button is checked, add a blue background */
.pe-radio input:checked~.checkmark {
  background-color: var(--radio-button-checked);
}

/* Create the indicator (the dot/circle - hidden when not checked) */
.checkmark:after {
  content: "";
  position: absolute;
  display: none;
}

/* Show the indicator (dot/circle) when checked */
.pe-radio input:checked~.checkmark:after {
  display: block;
}

/* Style the indicator (dot/circle) */
.pe-radio .checkmark:after {
  top: 4.5px;
  left: 4.5px;
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: white;
}

.loading-spinner {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 315px;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  font-size: 14px;
  background-color: rgba(128, 128, 128, 0.5); /* Gray transparent background */
  z-index: 1;
}

.error-message {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 315px;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  font-weight: bold;
  font-size: 14px;
  background-color: rgba(128, 128, 128, 0.5); /* Gray transparent background */
  color: red;
  z-index: 1;
}

.chart-wrapper {
  position: relative;
}

.chart-inner {
  position: relative;
  height: 300px;
}
</style>



// WEBPACK FOOTER //
// Presion.vue?2dc1f24c